/**
 * メニュー画面
 * 親コンポーネント
 */
import "bootstrap/dist/css/bootstrap.min.css";
import { React, useEffect, useRef, useState } from "react";
import { Await, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./css/App.css";

import axios from "axios";
import { useDispatch } from "react-redux";
import Jyuf101 from "./components/jyu/Jyuf101";
import Jyuf102 from "./components/jyu/Jyuf102";
import Jyuf104 from "./components/jyu/Jyuf104";
import Jyuf105 from "./components/jyu/Jyuf105";
import Skyf101 from "./components/sky/Skyf101";
import $ from 'jquery';
import isdFooter from "./components/common/isdFooter";
import Menu from "./components/common/menu";
import { retrieveKbn } from "./actions/pocActions/pocAction";
import { retrieveMessage, retrieveTni } from "./actions/pocActions/pocAction";
import authService from "./services/common/authService";
import sessionStore from "./store/sessionStore";
import rootScope from "./store/rootScopeStore";
import { observer } from "mobx-react";
import stateStore from "./store/stateStore";
import { getRequireFlg } from "./util/directive-utils";
import myGrid from "./store/myGridStore";
import { goto } from "./util/isd-utils";
import errMsgService from "./services/common/errMsgService";
import asyncService from "./services/common/asyncService";
import useIsMobile from "./util/useIsMobile";
import FunctionKey from "./util/functionKey";
import pocs from "./services/pocs";
import { isEmpty, reject } from "lodash";

let retrieveKbnData = null;
let retrieveMessageData = null;
let retrieveTniData = null;

const App = observer(() => {
    const [userdata, setUserData] = useState(null);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [isErrorForAlert, setIsErrorForAlert] = useState(false);
    const location = useLocation();
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const getUser = () => {
        new Promise((resolve, error) => {
            pocs.getUser().then((result) => {
                if (result.data?.result && !!result.data?.data?.loginDto) {
                    const loginDto = result.data.data.loginDto;
                    sessionStore.setAuth(loginDto);
                    setUserData(loginDto);
                    dispatch(asyncService.async(pocs.getShin(loginDto.tksakicd, loginDto.choaiskicd), (response) => {
                        const data = response.data;
                        if (data.length > 0) {
                            rootScope.hiddenFlg = false;
                            errMsgService.clearAllMsg();
                            sessionStore.setSuggestItems('shin', data);
                        } else {
                            // 得意先が存在しないケース
                            if (isEmpty(loginDto.tksaksskimei)) {
                                errMsgService.addMsgKey('EJYU0310');
                            // 得意先が存在するが、商品が存在しないケース
                            } else {
                                errMsgService.addMsgKey('EJYU0320');
                            }
                        }
                    }));
                    resolve();
                    goto('Menu');
                } else {
                    throw new Error();
                }
            }).catch(() => {
                //ログアウト
                if (!menudataNoLogin.find(menu => menu.path === window.location.pathname)) {
                    goto('Login');
                } else {
                    setUserData(null);
                }
            });
        })
    };

    useEffect(() => {
        setIsPanelOpen(true);
        retrieveKbnData = dispatch(retrieveKbn());
        retrieveMessageData = dispatch(retrieveMessage());
        retrieveTniData = dispatch(retrieveTni());
        myGrid.clear();
        rootScope.currentPage = window.location.pathname;
        rootScope.requireDisabledFlg = true;
        rootScope.hiddenFlg = true;
        rootScope.navigate = navigate;
        const auth = sessionStore.getAuth();

        if (!auth || (auth && !auth.tntocd) || (!!auth && !userdata)) {
            setUserData(null);
            getUser();
        }


        isdFooter.isDisabled();
    }, []);
    FunctionKey();
    setTimeout(() => {
        $("input").blur(function (event) {
            if (event.target.type !== 'text' && event.target.type !== 'password') return;
            rootScope.requireDisabledFlg = getRequireFlg();
            isdFooter.isDisabled();
        })
    }, 500);

    useEffect(() => {
        setIsErrorForAlert(rootScope.errors['isErrorForAlert']);
    }, [rootScope.errors['isErrorForAlert']]);

    useEffect(() => {
        errMsgService.clearAllMsg();
    }, [location]);

    let swithelm = [];
    let swithelmNoLogin = [];

    const menudata = [
        { path: "/Menu", swithpath: "/Menu", title: "Menu", component: <Menu /> },
        { path: "/Jyuf102", swithpath: "/Jyuf102", title: "Jyuf102", component: <Jyuf102 /> },
        { path: "/Jyuf104/1", swithpath: "/Jyuf104/:mode", title: "Jyuf104", component: <Jyuf104 /> },
        { path: "/Jyuf105", swithpath: "/Jyuf105", title: "Jyuf105", component: <Jyuf105 /> },
        { path: "/Skyf101", swithpath: "/Skyf101", title: "Skyf101", component: <Skyf101 /> },
    ];

    const menudataNoLogin = [
        { path: "/Login", swithpath: "/Login", title: "Login", component: <Jyuf101 /> },
        { path: "/Jyuf102", swithpath: "/Jyuf102", title: "Jyuf102", component: <Jyuf102 /> },
    ]

    //メニュー作成
    for (let i = 0; i < menudata.length; i++) {
        const url = window.location.href;
        let mode = '';
        if (url && url.includes(menudata[i].path)) {
            mode = url.split(menudata[i].path).pop() !== window.location.origin ? url.split(menudata[i].path).pop() : '';
        }
        swithelm.push(
            <Route path={mode ? `${menudata[i].swithpath}${mode}` : menudata[i].swithpath} element={menudata[i].component} />
        );
    }

    for (let i = 0; i < menudataNoLogin.length; i++) {
        const url = window.location.href;
        let mode = '';
        if (url && url.includes(menudataNoLogin[i].path)) {
            mode = url.split(menudataNoLogin[i].path).pop() !== window.location.origin ? url.split(menudataNoLogin[i].path).pop() : '';
        }
        swithelmNoLogin.push(
            <Route path={mode ? `${menudataNoLogin[i].swithpath}${mode}` : menudataNoLogin[i].swithpath} element={menudataNoLogin[i].component} />
        );
    }

    return (
        <>
            {/* {!isAuthenticated ? ( */}
            <nav className="navbar navbar-expand navbar-dark">
                <div className={(isMobile && (userdata?.tksaksskimei + userdata?.tntomei).length > 13) ?  "navbar-title-mobile" : "navbar-title"}>
                    <a href="/" className="navbar-brand">
                        トリゼンフーズ モバイル受注入力
                    </a>
                    {userdata && <div className="navbar-nav mr-auto">
                            <p>
                                <span>[{userdata.tksaksskimei}] </span>
                                <span>ようこそ {userdata.tntomei} さん</span>
                            </p>
                </div>}
                </div>
                <div className="navbar-btn">
                <form id="ssoLogout" method="post" action={window.location.origin + "/sasuga-mobile-api-torizen/logout"}>
                    {userdata && <input type="submit" className="btn btn-logout mt15" value="ログアウト" />}
                </form>
                </div>
            </nav>
            {!userdata ? (
                <div>

                    {isErrorForAlert && <div className={`alert alert-danger alert-dismissible ${window.location.pathname === menudataNoLogin[0].path ? 'alert-login' : ''}`} role="alert">
                        <span>{rootScope.errors.currentErrorMsg}</span>
                    </div>}
                    <div className={`${window.location.pathname !== menudataNoLogin[0].path ? 'container mt-3' : ''}`}>
                        <Routes>
                            <Route path='/' element={menudata[0].component} />
                            {swithelmNoLogin}
                        </Routes>
                    </div>
                    {rootScope.errors.isErrorForPanel && <div className={`fixed-box ${!Object.keys(rootScope.footer).length ? 'fixed-box-not-footer' : ''}`} >
                        <div className="panel-group" id="alertBox">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <div className="panel-title">
                                        <a data-toggle="collapse" data-parent="#alertBox" onClick={() => {
                                            setIsPanelOpen(!isPanelOpen);
                                        }}>
                                            エラー詳細
                                            <span className="badge">{rootScope.errors.length}</span>
                                            <i className={`glyphicon ${isPanelOpen === true ? "glyphicon-chevron-down" : "glyphicon-chevron-up"}`}></i>
                                        </a>
                                    </div>
                                </div>
                                <div id="alertPanel" className={`panel-collapse ${isPanelOpen === true ? "" : "collapse"} in`}>
                                    <div className="panel-body">
                                        <div className="text-list">
                                            <ul>
                                                {Object.values(rootScope.errors.panelmsg).map((errormsg) => (
                                                    <li key={errormsg}>{errormsg}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            ) : (
                <div>
                    <div className="container mt-3">
                        {isErrorForAlert && <div className="alert alert-danger alert-dismissible" role="alert">
                            <span>{rootScope.errors.currentErrorMsg}</span>
                        </div>}
                        <Await resolve={retrieveKbnData}>
                            <Routes>
                                <Route path='/' element={menudata[0].component} />
                                {swithelm}
                            </Routes>
                        </Await>
                    </div>
                    {rootScope.errors.isErrorForPanel && <div className={`fixed-box ${!Object.keys(rootScope.footer).length ? 'fixed-box-not-footer' : ''}`} >
                        <div className="panel-group" id="alertBox">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <div className="panel-title">
                                        <a data-toggle="collapse" data-parent="#alertBox" onClick={() => {
                                            setIsPanelOpen(!isPanelOpen);
                                        }}>
                                            エラー詳細
                                            <span className="badge">{rootScope.errors.length}</span>
                                            <i className={`glyphicon ${isPanelOpen === true ? "glyphicon-chevron-down" : "glyphicon-chevron-up"}`}></i>
                                        </a>
                                    </div>
                                </div>
                                <div id="alertPanel" className={`panel-collapse ${isPanelOpen === true ? "" : "collapse"} in`}>
                                    <div className="panel-body">
                                        <div className="text-list">
                                            <ul>
                                                {Object.values(rootScope.errors.panelmsg).map((errormsg) => (
                                                    <li key={errormsg}>{errormsg}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            )}
            {Object.keys(rootScope.footer).length ?
                <div className="page-menu-bottom clearfix">
                    <div className="page-menu-container container page-menu-bottom-box">
                        {rootScope.footer.infor &&
                            <div className="page-menu-bottom-left box" style={{ width: "50%" }}>
                                <ul className="inline">
                                    <li>
                                        <label>登録者名称</label>
                                        <input type="text" value={rootScope.footer?.ctrlState[rootScope.footer.infor]?.instntomei}
                                            className="w125 form-control ng-dirty move-focus ng-isolate-scope ng-empty ng-valid ng-valid-pattern" name="instntomei" disabled></input>
                                    </li>
                                    <li>
                                        <label>登録日時</label>
                                        <input type="text" value={rootScope.footer?.ctrlState[rootScope.footer.infor]?.insdate}
                                            className="w140 form-control ng-dirty move-focus ng-isolate-scope ng-empty ng-valid ng-valid-pattern" name="insdate" disabled></input>
                                    </li>
                                    <li>
                                        <label>更新者名称</label>
                                        <input type="text" value={rootScope.footer?.ctrlState[rootScope.footer.infor]?.updtntomei}
                                            className="w125 form-control ng-dirty move-focus ng-isolate-scope ng-empty ng-valid ng-valid-pattern" name="updtntomei" disabled></input>
                                    </li>
                                    <li>
                                        <label>更新日時</label>
                                        <input type="text" value={rootScope.footer?.ctrlState[rootScope.footer.infor]?.upddate}
                                            className="w140 form-control ng-dirty move-focus ng-isolate-scope ng-empty ng-valid ng-valid-pattern" name="upddate" disabled></input>
                                    </li>
                                </ul>
                            </div>
                        }
                        <div className="page-menu-bottom-right box">
                            <div className="form-btn-area">
                                <div>
                                    {
                                        rootScope.footer.otherBtn && rootScope.footer.otherBtn.length ?
                                            rootScope.footer.otherBtn.map(btn => (
                                                <button id={btn.id}
                                                    className="btn btn-outline-primary ml4 page-menu-btn-other"
                                                    onClick={btn.func}
                                                >{isdFooter.functionnamekeyDisp(btn.view)}</button>
                                            ))
                                            : ''
                                    }
                                    {!!rootScope.footer.clearBtn &&
                                        <button id="clearBtn"
                                            className="btn btn-other page-menu-btn-clear"
                                            onClick={isdFooter.footerClearBtnDef.func}>
                                            {isdFooter.functionnamekeyDisp(!!rootScope.footer.clearBtn.view ? rootScope.footer.clearBtn.view : "クリア", isMobile)}
                                        </button>}
                                    {(!!rootScope.footer.commitBtn && !rootScope.footer.commitBtn.hide) &&
                                        <button id="commitBtn"
                                            className="btn btn-primary page-menu-btn-commit"
                                            onClick={isdFooter.footerSubmitBtnDef.func}>
                                            {isdFooter.functionnamekeyDisp(!!rootScope.footer.commitBtn.view ? rootScope.footer.commitBtn.view : "確定")}
                                        </button>}
                                    {(rootScope.footer.endBtn && rootScope.footer.endBtn.hide)
                                        ? '' :
                                        <button id="endBtn" className="btn btn-other"
                                            onClick={rootScope.footer.endBtn && !!rootScope.footer.endBtn.func ? rootScope.footer.endBtn.func : isdFooter.footerEndBtnDef.func}>
                                            {isdFooter.functionnamekeyDisp(rootScope.footer.endBtn && !!rootScope.footer.endBtn.view
                                                ? rootScope.footer.endBtn.view : isdFooter.footerEndBtnDef.view, isMobile)}
                                        </button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <div className="page-menu-bottom clearfix"></div>}
        </>
    );
})

export default App;
